export default {
  menu: {
    edit_route: 'Edit the route',
    edit_tickType: 'Tick the route',
    edit_tickType_onsight: 'Onsight',
    edit_tickType_flash: 'Flash',
    edit_tickType_redpoint: 'Red point',
    edit_tickType_working: 'Project',
    add_comment: 'Comment the route',
    edit_comment: 'Edit my comment',
    add_grade: 'Suggest a different grade',
    edit_grade: 'Edit my grade suggestion',
    share_menu: 'Share the link',
    share_title: 'Route "{{route}}"',
    share_text: "Hey! Look at this route I just found on the {{spot}}'s topo",
  },
  button: {
    more: 'More',
    like: 'Like',
    unlike: 'Unlike',
    tick_working: 'Mark as project',
    tick_redpoint: 'Tick',
    untick_working: 'Not a project anymore',
    untick_redpoint: 'Cancel the tick',
  },
  filter: {
    placeholder: 'search a route…',
    button: 'Search',
    form: {
      colors: 'color',
      sectors: 'sector',
      lanes: 'lane',
      setters: 'setter',
      grades: 'grade',
      like: 'like',
      tick: 'tick',
    },
    sort: {
      date: 'Sort by settled date',
      grade: 'Sort by grade',
      like: 'Sort by number of like',
      comment: 'Sort by number of tick',
      lane: 'Sort by lane',
    },
  },
  tooltip: {
    filter: 'Display advanced filter options',
    reset: 'Elear search',
    filterTickType: {
      all: 'all',
      working: 'projects only',
      tick: 'ticked only',
      except: 'except ticked',
    },
    filterSort: 'Sort routes',
    filterGrade: '{{grade}}th grade',
    tickType: {
      onsight: 'Route led onsight on {{date}}',
      flash: 'Route led flash on {{date}}',
      redpoint: 'Route led on {{date}}',
      working: 'Projet since {{date}}',
    },
    liked: 'Route liked',
    draft: 'Not yet settled',
    archived: 'Route archived',
    variant: 'See the "{{choice}}" variant',
    likeCount_one: 'Liked by one climber',
    likeCount_other: 'Liked by one {{count}} climbers',
    tickCount_one: 'Ticked by one climber',
    tickCount_other: 'Ticked by one {{count}} climbers',
    workingCount_one: 'Project of a climber',
    workingCount_other: 'Project of {{count}} climbers',
  },
  helper: {
    undefined: 'undefined',
    comment: {
      eq_zero: 'No ascent',
      eq_one: 'One ascent',
      eq_other: '{{count}} ascents',
      less: 'Less than {{count}} ascents',
      more: 'More than {{count}} ascents',
      between: 'Between {{left}} and {{right}} ascents',
    },
    like: {
      eq_zero: 'No ❤️',
      eq_one: 'One ❤️',
      eq_other: '{{count}} ❤️',
      less: 'Less than {{count}} ❤️',
      more: 'More than {{count}} ❤️',
      between: 'Between {{left}} and {{right}} ❤️',
    },
    no_route: 'There are no route in the spot',
    no_route_create: 'Create the first route',
    no_route_filter: 'No route matching the current search',
    no_related_route: 'There are no similar route.',
    archived: 'The route has been archived.',
    counter_nofilter_zero: 'no routes',
    counter_nofilter_one: 'one route',
    counter_nofilter_other: '{{count}} routes',
    counter_filter_zero: 'no routes',
    counter_filter_one: '{{filtered}} / {{count}} route',
    counter_filter_other: '{{filtered}} / {{count}} routes',
    no_found: {
      title: 'Sorry, route not found!',
      body: 'We couldn’t find the route you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.',
    },
  },
  tabs: {
    ascent: 'Ascents',
    suggestion: 'Related routes',
  },
  related: {
    title: 'Related routes',
  },
  variation: {
    title: 'Available variants',
  },
  suggestion: {
    achievement: {
      first: 'Well done on your first tick 🥳',
      ticked: 'Well done on this new tick !',
      best: 'Congratulations pour ton premier {{grade}} 💪',
    },
    button: 'Show',
    switch: 'suggest similar routes',
    next: {
      vnew: 'What do you think about this new {{grade}} : "{{route}}" ?',
      v1: 'You might also like "{{route}}"',
      v2: 'Did you tried "{{route}}" ?',
    },
  },
}
